import React, { useState } from 'react';
import ConsultationModal from '../../components/ConsultationModal';
import img1 from '../../img/1.png';

function Maintenance() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 z-0">
          <img
            src={img1}
            alt="Hair system maintenance result"
            className="h-full w-full object-cover object-top opacity-40"
          />
          <div className="page-hero-scrim" />
        </div>
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">Ongoing care</p>
          <h1 className="font-display text-5xl font-semibold md:text-6xl">
            Maintenance & Reattachment
          </h1>
          <p className="mt-5 max-w-2xl text-xl text-white/85">
            Routine care to keep your hair replacement system clean, comfortable, secure, and natural-looking.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 md:grid-cols-2">
            <div>
              <p className="section-kicker">Maintenance services</p>
              <h2 className="section-heading">Keep your system fresh</h2>
              <div className="space-y-6">
                {[
                  {
                    title: 'System Cleaning',
                    items: ['Gentle system cleaning', 'Adhesive residue removal', 'Preparation for reattachment'],
                  },
                  {
                    title: 'Reattachment',
                    items: ['Secure placement', 'Fit adjustments', 'Hairline refresh'],
                  },
                  {
                    title: 'Wear Review',
                    items: ['Comfort check', 'Home care review', 'Next appointment planning'],
                  },
                ].map((block) => (
                  <div key={block.title} className="border-t border-primary-100 pt-5">
                    <h3 className="font-display text-2xl font-semibold text-ink">{block.title}</h3>
                    <ul className="mt-3 space-y-1 text-ink-muted">
                      {block.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-surface p-8">
              <h2 className="font-display text-3xl font-semibold text-ink">Maintenance planning</h2>
              <p className="mt-4 text-ink-muted">
                Timing depends on your system, attachment method, lifestyle, and comfort preferences.
              </p>
              <ul className="mt-6 space-y-3 text-ink-muted">
                <li>Flexible appointment timing</li>
                <li>Product and care guidance</li>
                <li>Support for longer-lasting wear</li>
              </ul>
              <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="mt-8 w-full rounded-full bg-primary-600 px-6 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700"
              >
                Schedule Maintenance
              </button>
            </div>
          </div>
        </div>
      </section>

      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        interest="Maintenance & Reattachment"
      />
    </div>
  );
}

export default Maintenance;
